import { useFormContext } from 'react-hook-form';
import React from 'react';
import { FormField, SearchField } from '@/components/custom/erp';
import { companyColums } from '../../cols-definition';
import type { DonViChiNhanh } from '@/types/schemas';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface InfoTabProps {
  mode: FormMode;
}

function InfoTab({ mode }: InfoTabProps) {
  const { register, setValue, watch } = useFormContext();
  const rowClassName = 'flex min-w-0 flex-col sm:flex-row sm:items-center';
  const labelClassName = 'mb-2 shrink-0 sm:mb-0 sm:w-40 sm:min-w-40';
  const fieldWrapClassName = 'min-w-0 flex-1';
  const inputClassName = 'w-full max-w-[360px]';

  const handleUnitSelection = (row: Pick<DonViChiNhanh, 'uuid' | 'ma_unit' | 'ten_unit'>) => {
    setValue('unit_id', row.uuid);
    setValue('ma_unit', row.ma_unit);
    setValue('unit_name', row.ten_unit || '');
  };

  return (
    <div className='min-w-0 max-w-full overflow-x-hidden p-4'>
      <div className='flex flex-col gap-y-4'>
        <div className='space-y-2'>
          <div className={rowClassName}>
            <Label className={labelClassName}>Đơn vị</Label>
            <SearchField
              type='text'
              searchEndpoint='/entity-units'
              searchColumns={companyColums}
              columnDisplay='ma_unit'
              displayRelatedField='ten_unit'
              className={inputClassName}
              classNameRelatedField='text-sm w-full'
              disabled={mode === 'view'}
              value={watch('ma_unit') || ''}
              relatedFieldValue={watch('unit_name') || ''}
              onRowSelection={handleUnitSelection}
            />
          </div>

          <div className={rowClassName}>
            <Label className={labelClassName}>Mã kho</Label>
            <div className={fieldWrapClassName}>
              <FormField type='text' name='ma_kho' className={inputClassName} disabled={mode === 'view'} />
            </div>
          </div>

          <div className={rowClassName}>
            <Label className={labelClassName}>Tên kho</Label>
            <div className={fieldWrapClassName}>
              <FormField type='text' name='ten_kho' className={inputClassName} disabled={mode === 'view'} />
            </div>
          </div>

          <div className={rowClassName}>
            <Label className={labelClassName}>Tên khác</Label>
            <div className={fieldWrapClassName}>
              <FormField type='text' name='ten_kho2' className={inputClassName} disabled={mode === 'view'} />
            </div>
          </div>

          <div className={`${rowClassName} py-1`}>
            <Label className={labelClassName}>Vị trí</Label>
            <FormField type='checkbox' name='vi_tri_yn' defaultValue={true} disabled={mode === 'view'} />
          </div>

          <div className={`${rowClassName} py-1`}>
            <Label className={labelClassName}>Đại lý</Label>
            <FormField type='checkbox' name='dai_ly_yn' defaultValue={true} disabled={mode === 'view'} />
          </div>

          <div className={rowClassName}>
            <Label className={labelClassName}>Địa chỉ</Label>
            <div className={fieldWrapClassName}>
              <FormField type='text' name='dia_chi' className={inputClassName} disabled={mode === 'view'} />
            </div>
          </div>

          <div className={rowClassName}>
            <Label className={labelClassName}>Điện thoại</Label>
            <div className={fieldWrapClassName}>
              <FormField type='text' name='dien_thoai' className={inputClassName} disabled={mode === 'view'} />
            </div>
          </div>

          <div className='flex min-w-0 flex-col sm:flex-row sm:items-start'>
            <Label className={labelClassName}>Ghi chú</Label>
            <div className={fieldWrapClassName}>
              <Textarea
                {...register('ghi_chu')}
                value={watch('ghi_chu') ?? ''}
                disabled={mode === 'view'}
                rows={2}
                className='min-h-[64px] w-full max-w-[560px] border-b text-sm'
              />
            </div>
          </div>

          <div className={rowClassName}>
            <Label className={labelClassName}>Trạng thái</Label>
            <div className={fieldWrapClassName}>
              <FormField
                type='select'
                name='status'
                className={inputClassName}
                options={[
                  { value: '1', label: '1. Còn sử dụng' },
                  { value: '0', label: '0. Không sử dụng' }
                ]}
                defaultValue='1'
                disabled={mode === 'view'}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoTab;
